import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InsuranceService {

  constructor(private http: HttpClient) {}

  getInsuranceData(formsId: number): Observable<any> {
    return this.http.get(`${environment.api_guia}forms/${formsId}/insurances`);
  }

  updateInsuranceData(formsId: number, insuranceId: number, data: any): Observable<any> {
    return this.http.patch(`${environment.api_guia}forms/${formsId}/insurances/${insuranceId}`, data);
  }
}
